import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { UtilsService } from "src/app/shared/services/utils.service";
import {
  AccessRequest,
  AccessRequestAdapter,
} from "../../models/access-request.model";
import {
  HydraoResponse,
  HydraoResponseAdapter,
} from "../../models/response.model";
import { HydraoApiService } from "../core/hydrao-api.service";

@Injectable({
  providedIn: "root",
})
export class AccessRequestService extends HydraoApiService<AccessRequest> {
  private accessRequestAdapter: AccessRequestAdapter =
    inject(AccessRequestAdapter);
  private utils: UtilsService = inject(UtilsService);
  private responseAdapter: HydraoResponseAdapter = inject(
    HydraoResponseAdapter
  );

  public getAccessRequestsForStore(): Observable<AccessRequest[]> {
    let url = "/users/me/access-requests";
    // this request do not use cache.
    return this.get(url, this.accessRequestAdapter, true, true) as Observable<
      AccessRequest[]
    >;
  }

  public getAccessRequests(): Observable<AccessRequest[]> {
    let url = "/users/me/access-requests";
    // this request do not use cache.
    return this.get(url, this.accessRequestAdapter) as Observable<
      AccessRequest[]
    >;
  }

  public acceptRequestForStore(userId: number): Observable<AccessRequest> {
    let url = `/users/me/access-requests/${userId}/validate`;
    //this.spinner.hide(); // execute silently //TODO
    // this request do not use cache.
    return this.post(url, null, null, false);
  }

  public denyRequestForStore(userId: number): Observable<any> {
    let url = `/users/me/access-requests/${userId}`;
    //this.spinner.hide(); // execute silently
    // this request do not use cache.
    return this.delete(url, false);
  }

  public acceptRequest(userId): Observable<any> {
    let url = `/users/me/access-requests/${userId}/validate`;
    //this.spinner.hide(); // execute silently //TODO
    // this request do not use cache.
    return this.post(url, null, null);
  }

  public denyRequest(userId): Observable<any> {
    let url = `/users/me/access-requests/${userId}`;
    //this.spinner.hide(); // execute silently
    // this request do not use cache.
    return this.delete(url);
  }

  public requestInvitation(email): Observable<HydraoResponse> {
    let url = `/users/${this.utils.toBase64Url(email)}/invitation`;

    return this.putResponse(
      url,
      {
        access_level: "admin",
      },
      this.responseAdapter
    );
  }
}
